"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookTemplateTab = void 0;
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../gen-src/Localize");
var CreateTemplateFlow_1 = require("./components/CreateTemplateFlow");
var LearnMoreLink_1 = require("./components/learn_more_link/LearnMoreLink");
var WorkbookTemplateItem_1 = require("./components/template_item/WorkbookTemplateItem");
var ErrorBoundary_1 = require("./error-boundary/ErrorBoundary");
var WorkbookTemplateWidgetsStyles_1 = require("./styles/WorkbookTemplateWidgetsStyles");
var JumpstartTelemetry_1 = require("./telemetry/JumpstartTelemetry");
var VizportalApi_1 = require("./vizportalapi/VizportalApi");
var WorkbookTemplateTab = /** @class */ (function (_super) {
    __extends(WorkbookTemplateTab, _super);
    function WorkbookTemplateTab(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFilterClose = function () {
            if (_this.closeDropdown) {
                _this.closeDropdown();
                _this.closeDropdown = undefined;
            }
        };
        _this.onLearnMoreLinkClick = function () {
            _this.JumpstartTelemetry.List.LearnMore.Click();
        };
        _this.state = { currentConnectionType: WorkbookTemplateTab.AllConnectionTypesValue };
        _this.onFilterSelection = _this.onFilterSelection.bind(_this);
        _this.onFilterOpen = _this.onFilterOpen.bind(_this);
        _this.onTemplateSelected = _this.onTemplateSelected.bind(_this);
        _this.JumpstartTelemetry = new JumpstartTelemetry_1.JumpstartTelemetry(props.sendEventFn);
        return _this;
    }
    WorkbookTemplateTab.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.sendEventFn !== prevProps.sendEventFn) {
            this.JumpstartTelemetry = new JumpstartTelemetry_1.JumpstartTelemetry(this.props.sendEventFn);
        }
    };
    WorkbookTemplateTab.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.JumpstartTelemetry.List.Open();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, VizportalApi_1.VizportalApiService.GetSessionInfo()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WorkbookTemplateTab.prototype.onTemplateSelected = function (templateId, connectionType, selectMethod) {
        // Let the caller know the user has selected a template
        // For vizclient to allows to close the connect-data dialog
        this.props.onTemplateSelected(templateId, connectionType);
        var selectedTemplate = this.props.templates.filter(function (template) { return template.id === templateId; })[0];
        this.JumpstartTelemetry.List.Select(templateId, selectedTemplate.name, connectionType, selectMethod);
        this.startCreateTemplateFlow(selectedTemplate);
    };
    WorkbookTemplateTab.prototype.startCreateTemplateFlow = function (template) {
        var _this = this;
        // Create the template flow element on a stacked element
        // so that it will live on when this tab element is unmounted
        var container = new widgets_1.HostedStackedElementContainer();
        var createTemplateFlowProps = {
            initialShowSelectProject: true,
            initialWorkbookName: template.name,
            connectionType: template.connectionType,
            templateId: template.id,
            helpVersion: this.props.helpVersion,
            siteName: this.props.siteName,
            JumpstartTelemetry: this.JumpstartTelemetry,
            onTemplateCreated: function (success, editUrl) {
                container.remove();
                _this.props.onTemplateCreated(success, editUrl);
            },
            onCancel: function () {
                container.remove();
                _this.props.onCancel();
            },
        };
        window.setTimeout(function () {
            container.render(React.createElement(CreateTemplateFlow_1.CreateTemplateFlow, __assign({}, createTemplateFlowProps)));
        }, 0);
    };
    WorkbookTemplateTab.prototype.onFilterSelection = function (newValue) {
        var _this = this;
        this.setState({ currentConnectionType: newValue }, function () { return _this.JumpstartTelemetry.List.Filter.Select(newValue); });
        this.handleFilterClose();
    };
    WorkbookTemplateTab.prototype.onFilterOpen = function (done) {
        this.closeDropdown = done;
        this.JumpstartTelemetry.List.Filter.Open();
    };
    WorkbookTemplateTab.prototype.connectionTypeMenuInfo = function () {
        var _this = this;
        var connectionTypes = this.props.connections
            .map(function (connectionType) {
            return { value: connectionType.internalName, content: connectionType.displayName };
        })
            .sort(function (a, b) { return _this.stringCompareHelper(a.content, b.content); });
        var menuInfo = [
            { value: WorkbookTemplateTab.AllConnectionTypesValue, content: Localize_1.Messages.AllConnectionTypes() },
        ];
        return menuInfo.concat(connectionTypes);
    };
    WorkbookTemplateTab.prototype.stringCompareHelper = function (value1, value2) {
        // Sort ignoring case
        return value1.toLowerCase().localeCompare(value2.toLowerCase());
    };
    WorkbookTemplateTab.prototype.renderHorizontalTitleBar = function () {
        // Top horizontal bar containing explanatory text and dropdown to filter by connection type.
        // Need additional div around DropdownWidget to ensure that dropdown does not get squashed by title text div.
        return (React.createElement(ErrorBoundary_1.ErrorBoundary, { ErrorTelemetry: this.JumpstartTelemetry.Error },
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsTabStyles.HorizontalTittleBar },
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsTabStyles.HorizontalTitleTextDiv },
                    Localize_1.Messages.TitleText(),
                    this.props.helpUrl && (React.createElement(LearnMoreLink_1.LearnMoreLink, { notifyOnClick: this.onLearnMoreLinkClick, testId: 'help-more-link', text: Localize_1.Messages.TitleLink(), helpUrl: this.props.helpUrl }))),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsTabStyles.HorizontalTitleDropdownDiv },
                    React.createElement(widgets_1.SingleSelectDropdown, { value: this.state.currentConnectionType, onChange: this.onFilterSelection, onOpen: this.onFilterOpen, onClose: this.handleFilterClose, type: widgets_1.DropdownButtonType.Text, list: React.createElement(widgets_1.List, { items: this.connectionTypeMenuInfo() }), testId: 'select-connectionType-type-id', label: '', zIndex: 1031 })))));
    };
    WorkbookTemplateTab.prototype.renderTemplateList = function () {
        var _this = this;
        // Filter templates by connection type dropdown
        var templates = this.props.templates.filter(function (template) {
            return (_this.state.currentConnectionType === WorkbookTemplateTab.AllConnectionTypesValue ||
                _this.state.currentConnectionType === template.connectionType.internalName);
        });
        // Create DOM element for each remaining template
        var templatesComponents = templates.map(function (template, index) {
            // Add horizontal line below template item except for last item
            var horizontalLine = index + 1 < templates.length ? React.createElement("hr", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsTabStyles.HorizontalLine }) : null;
            // Give first item less top margin for better looks
            var marginTop = index === 0 ? widgets_1.TabStyles.Spacing.SmallSpace : widgets_1.TabStyles.Spacing.MediumSpace;
            return (React.createElement(ErrorBoundary_1.ErrorBoundary, { key: template.id, ErrorTelemetry: _this.JumpstartTelemetry.Error },
                React.createElement("div", { key: template.id, style: { marginTop: marginTop } },
                    React.createElement(WorkbookTemplateItem_1.WorkbookTemplateItem, { key: template.id, template: template, onTemplateSelected: _this.onTemplateSelected }),
                    horizontalLine)));
        });
        return templatesComponents;
    };
    WorkbookTemplateTab.prototype.render = function () {
        return (React.createElement("div", { id: this.props.testId, className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsTabStyles.ContainerDiv },
            this.renderHorizontalTitleBar(),
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsTabStyles.HorizontalScrollDiv }, this.renderTemplateList())));
    };
    WorkbookTemplateTab.AllConnectionTypesValue = 'All';
    return WorkbookTemplateTab;
}(React.Component));
exports.WorkbookTemplateTab = WorkbookTemplateTab;
//# sourceMappingURL=WorkbookTemplateTab.js.map